// import React, { useEffect, useMemo, useState, useRef } from 'react';
// import {
//   Stack,
//   IconButton,
//   Tooltip,
//   Box,
//   Popover,
//   Typography,
// } from '@mui/material';
// import { History } from '@mui/icons-material';
// import SettingsVoiceOutlinedIcon from '@mui/icons-material/SettingsVoiceOutlined';
// import PhotoIcon from '@mui/icons-material/PhotoFilter';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import { useSelector, useDispatch } from 'react-redux';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';
// import { fetchUserCredits } from '../../redux/userSlice'; // <-- IMPORT THE ACTION

// const BlueText = ({ children, bold = false }) => (
//   <Box
//     component="span"
//     color={'primary.300'}
//     sx={{ fontWeight: bold ? 600 : 'inherit' }}
//   >
//     {children}
//   </Box>
// );

// function AppMenu(props) {
//   // Styles remain the same
//   const iconButtonStyle = {
//     border: '1px solid var(--grey-100)',
//     bgcolor: 'var(--grey-0)',
//     width: 38,
//     height: 38,
//     borderRadius: '10px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     color: 'text.primary',
//     '&:hover': {
//       borderColor: 'var(--primary-300)',
//       color: 'var(--primary-300)',
//       bgcolor: 'var(--grey-0)',
//     },
//   };
//   const activeStyle = {
//     bgcolor: 'var(--grey-0)',
//     borderColor: 'var(--primary-300)',
//     color: 'var(--primary-300)',
//   };

//   // Local UI state
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [snackbar, setSnackbar] = React.useState({
//     open: false,
//     message: '',
//     severity: 'info',
//   });

//   // Redux hooks
//   const dispatch = useDispatch();
//   const transScriptSession = useSelector(
//     state => state.sessionDetail.transScriptSession
//   );
//   const credits = useSelector(state => state.user.credits);
//   const creditsStatus = useSelector(state => state.user.status);

//   // Effect to fetch credits on load
//   React.useEffect(() => {
//     if (transScriptSession && creditsStatus === 'idle') {
//       dispatch(fetchUserCredits(transScriptSession));
//     }
//   }, [transScriptSession, creditsStatus, dispatch]);

//   // Effect to show snackbar based on credits
//   React.useEffect(() => {
//     if (credits === null) return;
//     if (creditsStatus === 'failed') return;
//     if (credits <= 0) {
//       setSnackbar({
//         open: true,
//         message: 'You have run out of credits. Transcription will stop.',
//         severity: 'error',
//       });
//     } else if (credits > 0 && credits < 6) {
//       setSnackbar({
//         open: true,
//         message: `Warning: You have only ${credits} credits remaining.`,
//         severity: 'warning',
//       });
//     }
//   }, [credits, creditsStatus]);

//   // Event Handlers
//   const handleClick = event => {
//     setAnchorEl(event.currentTarget);
//     if (transScriptSession) {
//       dispatch(fetchUserCredits(transScriptSession));
//     }
//   };
//   const handleClose = () => setAnchorEl(null);
//   const handleCloseSnackbar = (event, reason) => {
//     if (reason === 'clickaway') return;
//     setSnackbar(prev => ({ ...prev, open: false }));
//   };

//   const open = Boolean(anchorEl);
//   const id = open ? 'simple-popover' : undefined;

//   return (
//     <Box
//       sx={{
//         padding: { xs: '0 0 16px 0', sm: '16px 16px 0 8px' },
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       <Stack spacing={1.5} direction={{ xs: 'row', sm: 'column' }}>
//         {/* Transcript and History Buttons... */}
//         <Tooltip title="Transcript" placement="right" arrow>
//           <IconButton
//             onClick={() => {
//               props.setMenuSeleted('transcript');
//               if (transScriptSession) {
//                 dispatch(fetchUserCredits(transScriptSession));
//               }
//             }}
//             sx={{
//               ...iconButtonStyle,
//               ...(props.menuSelected === 'transcript' ? activeStyle : {}),
//             }}
//           >
//             <SettingsVoiceOutlinedIcon />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="History" placement="right" arrow>
//           <IconButton
//             onClick={() => {
//               props.setMenuSeleted('history');
//               if (transScriptSession) {
//                 dispatch(fetchUserCredits(transScriptSession));
//               }
//             }}
//             sx={{
//               ...iconButtonStyle,
//               ...(['history', 'transcriptRedirected'].includes(
//                 props.menuSelected
//               )
//                 ? activeStyle
//                 : {}),
//             }}
//           >
//             <History />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Recycle Bin" placement="right" arrow>
//           <IconButton
//             onClick={() => {
//               props.setMenuSeleted('deleted');
//               if (transScriptSession) {
//                 dispatch(fetchUserCredits(transScriptSession));
//               }
//             }}
//             sx={{
//               ...iconButtonStyle,
//               ...(props.menuSelected === 'deleted'
//                 ? {
//                     ...activeStyle,
//                     borderColor: 'error.main',
//                     color: 'error.main',
//                   }
//                 : {}),
//             }}
//           >
//             <DeleteOutlineIcon />
//           </IconButton>
//         </Tooltip>
//       </Stack>
//       <Tooltip title="Credits Utilized" placement="top" arrow>
//         <IconButton
//           sx={{
//             ...iconButtonStyle,
//             ...(open ? activeStyle : {}),
//             marginTop: 'auto',
//           }}
//           onClick={handleClick}
//         >
//           <PhotoIcon />
//         </IconButton>
//       </Tooltip>
//       <Popover
//         id={id}
//         open={open}
//         anchorEl={anchorEl}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//         transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
//         slotProps={{
//           paper: {
//             sx: {
//               borderRadius: '10px',
//               boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.20)',
//               padding: 2,
//               width: 340,
//               lineHeight: 'normal',
//               ml: 1,
//             },
//           },
//         }}
//       >
//         <Box display="flex" alignItems="center" gap={0.5}>
//           <PhotoIcon fontSize="small" />
//           <Typography variant="body2" color="text.primary">
//             Credits Available
//           </Typography>
//         </Box>
//         <Typography variant="body2" color="text.primary" my={1}>
//           <BlueText bold>{credits === null ? 'Loading...' : credits}</BlueText>{' '}
//           available out of <BlueText bold>60</BlueText> free credits
//         </Typography>
//         <Typography
//           variant="caption"
//           sx={{ display: 'block' }}
//           color="grey.500"
//           lineHeight={'normal'}
//         >
//           ~ Less than{' '}
//           <BlueText>5 mins = 0.5 credit. 5-10 mins = 1 credit.</BlueText> Beyond{' '}
//           <BlueText>10 mins</BlueText>, credits are added in{' '}
//           <BlueText>5-minute blocks</BlueText>. (Example: 22-minute transcript =
//           2.5 credits).
//         </Typography>
//       </Popover>
//       <Snackbar
//         open={snackbar.open}
//         onClose={handleCloseSnackbar}
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// export default AppMenu;




import React from 'react';
import {
  Box,
  Tooltip,
  Popover,
  Typography,
  Drawer as MuiDrawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  History,
  SettingsVoiceOutlined as SettingsVoiceOutlinedIcon,
  PhotoFilter as PhotoIcon,
  DeleteOutline as DeleteOutlineIcon,
  Menu as MenuIcon,
  MenuOpen as MenuOpenIcon,
  BorderRight,
  Mic as MicIcon,
  Home as HomeIcon,
  MoreVert as MoreIcon,
} from '@mui/icons-material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { styled, useTheme, keyframes } from '@mui/material/styles';
import { useSelector, useDispatch } from 'react-redux';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { fetchUserCredits } from '../../redux/userSlice';
import { isMobile, isTablet } from 'react-device-detect';
import MobileUserProfile from './MobileUserProfile';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES, isTranscriptRoute } from '../../routes';
import { FeedbackWidget } from './FeedbackWidget.js';

// --- Dimensions & Constants ---
const DRAWER_WIDTH = 200;
const COLLAPSED_WIDTH = 75;

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  overflowX: 'hidden',
  width: COLLAPSED_WIDTH,
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: open ? DRAWER_WIDTH : COLLAPSED_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    height: '100%', 
    
    '& .MuiDrawer-paper': {
      position: 'relative', 
      whiteSpace: 'nowrap',
      height: '100%', 
      backgroundColor: 'var(--grey-0)',
      BorderRight: '1px solid var(--grey-100)',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      zIndex: 99,

      // Apply animations
      ...(open && openedMixin(theme)),
      ...(!open && closedMixin(theme)),
    },
    '& .MuiDrawer-root': {
        border: 'none' 
    }
  }),
);

// Animation keyframes for the red dot
const animateLoader38 = keyframes`
  0% {
    transform: scale(1);
  }
  50%, 75% {
    transform: scale(2.5);
  }
  80%, 100% {
    opacity: 0;
  }
`;

// Styled component for animated dot
const AnimatedDot = styled(Box)({
  position: 'absolute',
  top: '-3px',
  right: '0px',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  backgroundColor: '#f44336',
  border: '2px solid white',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
  '&::before': {
    content: '""',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    borderRadius: '50%',
    backgroundColor: '#f94346',
    opacity: 0.5,
    transformOrigin: 'center',
    animation: `${animateLoader38} 2s ease-out infinite`,
    animationDelay: '0.8s',
  },
});

const BlueText = ({ children, bold = false }) => (
  <Box
    component="span"
    color={'primary.300'}
    sx={{ fontWeight: bold ? 600 : 'inherit' }}
  >
    {children}
  </Box>
);

function AppMenu(props) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  // Get recording state from Redux for mobile navbar visibility
  const isRecording = useSelector(state => state.currentMeetingDetails.isRecording);
  const isStarted = useSelector(state => state.currentMeetingDetails.isStarted);
  const stopped = useSelector(state => state.currentMeetingDetails.stopped);
  const paused = useSelector(state => state.currentMeetingDetails.paused);
  
  // Determine if transcription is active (recording, started, or paused but not stopped)
  // Track transcription activity (recording or started and not stopped)
  const isTranscriptionActive = isRecording || (isStarted && !stopped);

  // Determine current route for active state
  const currentPath = location.pathname;
  const isTranscript = isTranscriptRoute(currentPath);
  const isHistoryDetail = currentPath.startsWith('/transcribe/meeting/');
  const isBinDetail = currentPath.startsWith('/transcribe/bin/meeting/');
  const isHistory = currentPath === ROUTES.HISTORY || isHistoryDetail;
  const isBin = currentPath === ROUTES.BIN || isBinDetail;
  
  // Navbar should only be visible on exact history route (not meeting detail pages),
  // even if a meeting is currently recording. It must stay hidden on other routes.
  const isExactHistoryRoute = currentPath === ROUTES.HISTORY;
  const shouldShowNavbar = isExactHistoryRoute;

  // Map current route to menuSelected-like value for compatibility
  const menuSelected = React.useMemo(() => {
    if (isBin) return 'deleted';
    if (isHistory) return 'history';
    if (isTranscript) return 'transcript';
    return 'transcript';
  }, [isBin, isHistory, isTranscript]);

  // --- State ---
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: '',
    severity: 'info',
  });
  const [showUserProfile, setShowUserProfile] = React.useState(false);
  const [showStartMeetingDialog, setShowStartMeetingDialog] = React.useState(false);

  // Redux hooks
  const dispatch = useDispatch();
  const transScriptSession = useSelector(
    (state) => state.sessionDetail.transScriptSession
  );
  const credits = useSelector((state) => state.user.credits);
  const creditsStatus = useSelector((state) => state.user.status);
  const userInformation = useSelector((state) => state.userDetails?.userData || {});

  const getInitials = (name = '') => {
    const parts = name.trim().split(' ').filter(Boolean);
    if (!parts.length) return 'U';
    const first = parts[0][0] || '';
    const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
    return `${first}${last}`.toUpperCase() || 'U';
  };

  React.useEffect(() => {
    if (transScriptSession && creditsStatus === 'idle') {
      dispatch(fetchUserCredits(transScriptSession));
    }
  }, [transScriptSession, creditsStatus, dispatch]);

  // Effect to show snackbar based on credits
  React.useEffect(() => {
    if (credits === null) return;
    if (creditsStatus === 'failed') return;
    if (credits <= 0) {
      setSnackbar({
        open: true,
        message: 'You have run out of credits. Transcription will stop.',
        severity: 'error',
      });
    } else if (credits > 0 && credits < 6) {
      setSnackbar({
        open: true,
        message: `Warning: You have only ${credits} credits remaining.`,
        severity: 'warning',
      });
    }
  }, [credits, creditsStatus]);

  // --- Handlers ---
  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  // Navigation handler using React Router
  const handleNavClick = (view) => {
    // Map view names to routes
    const routeMap = {
      'transcript': ROUTES.HOME,
      'history': ROUTES.HISTORY,
      'deleted': ROUTES.BIN,
    };

    const targetRoute = routeMap[view];
    if (targetRoute) {
      navigate(targetRoute);
    }

    if (transScriptSession) {
      dispatch(fetchUserCredits(transScriptSession));
    }
  };

  const handleCreditsClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (transScriptSession) {
      dispatch(fetchUserCredits(transScriptSession));
    }
  };

  const handleMicClick = () => {
    // Close User Profile if it's open
    if (showUserProfile) {
      setShowUserProfile(false);
    }
    
    // If meeting is ongoing, proceed directly without confirmation
    if (isTranscriptionActive) {
      navigate(ROUTES.HOME);
      if (isMobile || isTablet) {
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('startMeetingFromMic'));
        }, 100);
      }
    } else {
      // Show confirmation dialog for mobile/tablet view
      if (isMobile || isTablet) {
        setShowStartMeetingDialog(true);
      } else {
        // Desktop: proceed directly
        navigate(ROUTES.HOME);
      }
    }
  };

  const handleStartMeetingContinue = () => {
    setShowStartMeetingDialog(false);
    navigate(ROUTES.HOME);
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('startMeetingFromMic'));
    }, 100);
  };

  const handleStartMeetingDiscard = () => {
    setShowStartMeetingDialog(false);
  };

  const handleClose = () => setAnchorEl(null);
  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const openPopover = Boolean(anchorEl);
  const popoverId = openPopover ? 'simple-popover' : undefined;

  React.useEffect(() => {
    const handler = () => {
      setOpenDrawer(prev => !prev);
    };
    window.addEventListener('toggleAppMenuDrawer', handler);
    return () => window.removeEventListener('toggleAppMenuDrawer', handler);
  }, []);

  React.useEffect(() => {
    try {
      window.dispatchEvent(
        new CustomEvent('appMenuDrawerState', { detail: { open: openDrawer } })
      );
    } catch (e) {
    }
  }, [openDrawer]);


const getCommonListItemStyle = (isOpen, active, isError = false) => {
       const activeColor = isError ? 'error.main' : 'var(--primary-300)';

    return {
      minHeight: 52,
      justifyContent: isOpen ? 'initial' : 'center',
      borderRadius: '12px',
      border: active ? '1px solid' : '1px solid transparent',
      borderColor: active ? activeColor : 'transparent',
      color: active ? activeColor : 'text.primary',
        
     '&:hover': {
        borderColor: activeColor,
        color: activeColor,
        bgcolor: 'var(--grey-0)',
      },
    };
  };



  // --- List Item Renderer ---
  const renderListItem = (label, value, icon, onClickOverride = null) => {
    const isSelected =
      menuSelected === value ||
      (value === 'history' && currentPath.startsWith('/transcribe/meeting/'));

    const isCredits = value === 'credits';
    const active = isCredits ? openPopover : isSelected;
    const isError = value === 'deleted';
    const isTranscript = value === 'transcript';
    const showRedDot = isTranscript && isTranscriptionActive;

    return (
      <ListItem disablePadding sx={{ display: 'block', mb: 1, px: 1.5,
        '& .MuiList-root': {paddingTop:'18px'}
       }}>
        {/* Tooltip only shown when drawer is collapsed */}
        <Tooltip title={openDrawer ? '' : label} placement="right" arrow>
          <ListItemButton
            onClick={onClickOverride || (() => handleNavClick(value))}
            sx={getCommonListItemStyle(openDrawer, active, isError)}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                // Margin logic for transition
                mr: openDrawer ? 2 : 'auto',
                justifyContent: 'center',
                color: 'inherit',
                position: 'relative',
              }}
            >
              {icon}
              {/* Red dot indicator when meeting is ongoing */}
              {showRedDot && <AnimatedDot />}
            </ListItemIcon>
            <ListItemText
              primary={label}
              sx={{ opacity: openDrawer ? 1 : 0 }}
              primaryTypographyProps={{
                fontSize: '14px',
                fontWeight: active ? 600 : 400,
                whiteSpace: 'nowrap',
              }}
            />
          </ListItemButton>
        </Tooltip>
      </ListItem>
    );
  };


  const renderPopoverAndSnackbar = () => (
    <>
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: (isMobile || isTablet) ? 'top' : 'bottom',
          horizontal: (isMobile || isTablet) ? 'center' : 'right',
        }}
        transformOrigin={{
          vertical: (isMobile || isTablet) ? 'bottom' : 'bottom',
          horizontal: (isMobile || isTablet) ? 'center' : 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: '10px',
              boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.20)',
              padding: 2,
              width: 340,
              ml: (isMobile || isTablet) ? 0 : 2,
              mb: (isMobile || isTablet) ? 2 : 0,
            },
          },
        }}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <PhotoIcon fontSize="small" />
          <Typography variant="body2" color="text.primary">
            Credits Available
          </Typography>
        </Box>
        <Typography variant="body2" color="text.primary" my={1}>
          <BlueText bold>{credits === null ? 'Loading...' : credits}</BlueText>{' '}
          available
           {/* out of <BlueText bold>60</BlueText> free credits */}
        </Typography>
        <Typography
          variant="caption"
          sx={{ display: 'block' }}
          color="grey.500"
          lineHeight={'normal'}
        >
          ~ Less than{' '}
          <BlueText>5 mins = 0.5 credit. 5-10 mins = 1 credit.</BlueText> Beyond{' '}
          <BlueText>10 mins</BlueText>, credits are added in{' '}
          <BlueText>5-minute blocks</BlueText>. (Example: 22-minute transcript =
          2.5 credits).
        </Typography>
      </Popover>
      <Snackbar
        open={snackbar.open}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );

  // Mobile/Tablet View
  if (isMobile || isTablet) {
    const isHistoryActive = isHistory || currentPath.startsWith('/transcribe/meeting/');
    const isAccountActive = showUserProfile || isBin;

    return (
      <>
        {showUserProfile && (
          <MobileUserProfile
            userInformation={userInformation}
            credits={credits}
            onBack={() => {
              setShowUserProfile(false);
              navigate(ROUTES.HOME);
            }}
            onTerms={() => props.setTermsConditionFlag?.(true)}
            onLogout={props.onLogout}
            onDeleteClick={() => {
              setShowUserProfile(false);
              navigate(ROUTES.BIN);
            }}
            setShowUserProfile={setShowUserProfile}
          />
        )}

        <Box
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            width: '100%',
            height: '80px', 
            display: shouldShowNavbar ? 'flex' : 'none', // Show navbar only on history route and when transcription is not active
            justifyContent: 'center',
            alignItems: 'flex-end', 
            zIndex: 1200,
            filter: 'drop-shadow(0 -4px 12px rgba(0,0,0,0.06))',
            pointerEvents: 'none',
            transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
            opacity: shouldShowNavbar ? 1 : 0,
            transform: shouldShowNavbar ? 'translateY(0)' : 'translateY(100%)',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              height: '60px', 
              display: 'flex',
              alignItems: 'flex-start',
              pointerEvents: 'auto', 
            }}
          >
            <Box sx={{ flex: 1, height: '100%', background: 'white' }} />
            <Box
              component="svg"
              viewBox="0 0 100 60"
              preserveAspectRatio="none"
              sx={{
                width: '120px',
                height: '60px',
                fill: 'white',
                marginTop: '-1px',
                display: 'block',
              }}
            >
              <path d="M0,0 C20,0 25,40 50,40 C75,40 80,0 100,0 V60 H0 Z" />
            </Box>
            <Box sx={{ flex: 1, height: '100%', background: '#ffffff' }} />
          </Box>

          <Box
            sx={{
              position: 'relative',
              width: '100%',
              height: '60px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 40px',
              zIndex: 2,
              pointerEvents: 'none',
            }}
          >
            <Box
              onClick={() => {
                setShowUserProfile(false);
                navigate(ROUTES.HISTORY);
              }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                pointerEvents: 'auto',
                transition: 'color 0.3s',
                color: isHistoryActive ? 'var(--primary-300)' : '#9e9e9e',
                width: '60px',
              }}
            >
              <HomeIcon sx={{ fontSize: '28px', mb: 0.5 }} />
              <Typography
                variant="caption"
                sx={{ fontSize: '12px', fontWeight: 500 }}
              >
                Home
              </Typography>
            </Box>

            <Box sx={{ width: '56px' }} />
            <Box
              onClick={() => setShowUserProfile(true)}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                pointerEvents: 'auto',
                transition: 'color 0.3s',
                color: isAccountActive ? 'var(--primary-300)' : '#9e9e9e',
                width: '60px',
              }}
            >
              <PersonOutlineOutlinedIcon sx={{ fontSize: '28px', mb: 0.5 }} />
              <Typography
                variant="caption"
                sx={{ fontSize: '12px', fontWeight: 500 }}
              >
                Account
              </Typography>
            </Box>
          </Box>

          {/* 3. Floating Action Button (Mic) */}
          <Box
            sx={{
              position: 'absolute',
              top: '-6px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 3,
            }}
          >
            <IconButton
              onClick={handleMicClick}
              sx={{
                width: '56px',
                height: '56px',
                background: 'linear-gradient(180deg, #3bb7ff, #1e90ff)', 
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 8px 20px rgba(30, 144, 255, 0.4)',
                color: 'white',
                pointerEvents: 'auto',
                position: 'relative',
                ...(isTranscriptionActive && {
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: '20%',
                    left: '23%',
                    transform: 'translate(-50%, -50%)',
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    backgroundColor: '#1e90ff',
                    opacity: 0.5,
                    zIndex: -1,
                    animation: `${animateLoader38} 1.5s ease-out infinite`,
                    animationDelay: '0.8s',
                  },
                }),
                '&:hover': {
                  background: 'linear-gradient(180deg, #5397f4 0%, #096bef 100%)',
                },
              }}
            >
              <MicIcon sx={{ fontSize: '30px' }} />
              {/* Green dot indicator when meeting is ongoing on history page */}
              {isExactHistoryRoute && isTranscriptionActive && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '4px',
                    right: '4px',
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: 'error.main',
                    border: '2px solid white',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                  }}
                />
              )}
            </IconButton>
          </Box>
        </Box>

        {renderPopoverAndSnackbar()}
        
        {/* Start Meeting Confirmation Dialog */}
        <Dialog
          open={showStartMeetingDialog}
          onClose={handleStartMeetingDiscard}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: '12px',
            },
          }}
        >
          <DialogTitle>
            <Typography variant="h6" component="span" fontWeight={600}>
              Start Meeting
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" color="text.primary">
              Are you sure you want to start a new meeting?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={handleStartMeetingDiscard}
              variant="outlined"
              color="primary"
              sx={{ minWidth: 100 }}
            >
              Discard
            </Button>
            <Button
              onClick={handleStartMeetingContinue}
              variant="contained"
              color="primary"
              sx={{ minWidth: 100 }}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
  // ---Desktop/Tablet (Mini Drawer) ---
  return (
    <Box
      sx={{
        padding: '0px 0px 0 0px',
        height: '100%', 
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Drawer variant="permanent" open={openDrawer}>
        <List sx={{ display: 'flex', flexDirection: 'column', height: '100%',paddingTop:'18px' }}>
          <Box>
            {renderListItem('Transcript', 'transcript', <SettingsVoiceOutlinedIcon />)}
            {renderListItem('History', 'history', <History />)}
            {renderListItem('Recycle Bin', 'deleted', <DeleteOutlineIcon />)}
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <Box>
            <FeedbackWidget
              userName={userInformation?.username}
              userEmail={userInformation?.email}
              isDrawerOpen={openDrawer}
            />
          </Box>
          <Box>
            {renderListItem('Credits', 'credits', <PhotoIcon />, handleCreditsClick)}
          </Box>
        </List>
      </Drawer>
      {renderPopoverAndSnackbar()}
    </Box>
  );
}

export default AppMenu;
